export class AsyncLock {
  constructor() {
    this.disable = () => {}
    this.promise = Promise.resolve()
  }

  async lock() {
    await this.promise
    this.promise = new Promise((resolve) => (this.disable = resolve))
  }

  unlock() {
    this.disable()
  }
}
